module.exports = __webpack_public_path__ + "img/dermapen.df2d6484.png";